module.exports = __webpack_public_path__ + "img/close.088f4c81.svg";